var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"text-center text-md-h4 text-h4",attrs:{"cols":"12"}},[_vm._v(" Looks like you are lost ")]),_c('v-col',{staticClass:"text-center text-md-h4 text-h4",attrs:{"cols":"12"}},[_vm._v(" Click "),_c('router-link',{attrs:{"to":"/"}},[_vm._v(" here ")]),_vm._v(" to go to home page ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }